import './App.css';
import { Route, Routes } from "react-router-dom";
import React from 'react';
import Landing from './components/Landing';
import VideoDisplay from './components/VideoDisplay';

export const config = {
  endpoint: `https://11c5a109-fb92-43a7-8091-76768c9c1b7f.mock.pstmn.io`
}

function App() {
  return (
    <React.StrictMode>
      <div className="App">
          
        <Routes>
          <Route path='/videos/:id' element={<VideoDisplay />} />
          <Route exact path='/' element={<Landing />} />
        </Routes>

      </div>     
    </React.StrictMode>
  );
}

export default App;
